import { User } from "../User";
import { IPlaceReport } from "../models/Models";
import { IDataProvider } from "./IDataProvider";

export function userCanEditPlaceReport(user: User | undefined, report: IPlaceReport) {
    // guest users can't edit anything
    if (!user) {
        return false;
    }

    // any logged in user can add a report
    if (report.id.length === 0) {
        return true;
    }

    // only the submitting user and admins can edit and delete reports
    return user.id === report.owner || user.isAdmin();
}

export abstract class IPlaceReportTable extends IDataProvider<IPlaceReport> {
    public abstract allByPlaceId(id: string, ..._args: any[]): Promise<IPlaceReport[] | undefined>;
}
